import { Component, OnInit, HostBinding } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import * as support from '../../actions/support';
import * as youtubeModal from '../../actions/youtube-modal';
import { Subscription, Observable } from 'rxjs';
import { SocialMediaLinks } from '../../interfaces';

@Component({
  selector: 'edge-support-soccer',
  templateUrl: './support-soccer.component.html',
  styleUrls: ['./support-soccer.component.scss']
})
export class PageSupportSoccerComponent implements OnInit {
  sport = 'Soccer';
  header1 = 'Companion Videos';
  videos1 = [
    {
      title: 'Getting Started',
      youtubeid: 'Sv2zDNpomQQ',
      youtubethumb: '/assets/images/support/thumbs/s-gettingstarted.jpg',
      description: `This video shows a new user how to setup a GoArmy Edge
      Soccer account and takes a quick tour of the features.`
    },
    {
      title: 'Drawing Plays and Activities',
      youtubeid: 'kMZrey4DScw',
      youtubethumb:
        '/assets/images/support/thumbs/s-drawingplaysandactivities.jpg',
      description: `This video demonstrates how to draw plays, concepts,
        and activities in GoArmy Edge Soccer.`
    },
    {
      title: 'Making Content for Players',
      youtubeid: '8g0h9uY0-YM',
      youtubethumb:
        '/assets/images/support/thumbs/s-makingcontentforplayers.jpg',
      description: `This video will introduce users to Coaching Points,
        turning your concepts into presentations for your players in
        GoArmy Edge Soccer.`
    },
    {
      title: 'Managing Your Team',
      youtubeid: '1rejvABmMko',
      youtubethumb: '/assets/images/support/thumbs/s-managingyourteam.jpg',
      description: `This video will explain the tools admins and coaches have
        for team management in GoArmy Edge Soccer.`
    },
    {
      title: 'Changing Player Look',
      youtubeid: 'zCwG-uj2A_8',
      youtubethumb: '/assets/images/support/thumbs/s-changingplayerlook.jpg',
      description: `This video will explain how to change all the aspects of
        your team's appearance in GoArmy Edge Soccer, including colors, numbers,
        and visibility.`
    }
  ];

  socialMediaLinks$: Observable<SocialMediaLinks> = this.store.select(
    fromRoot.getSocialMediaLinks
  );
  socialMediaLinksSubscription: Subscription = new Subscription();
  socialMediaLinks?: SocialMediaLinks;

  constructor(private store: Store<fromRoot.State>) {}

  ngOnInit(): void {
    this.store.dispatch(support.ToggleSupportPageAction('soccer'));

    this.socialMediaLinksSubscription = this.socialMediaLinks$.subscribe(
      (links) => {
        this.socialMediaLinks = links;
      }
    );
  }

  scrollToSection(sectionId: string): void {
    const section = document.getElementById(sectionId);
    section!.scrollIntoView({ behavior: 'smooth' });
  }

  showModal(id: string, show?: boolean): void {
    this.store.dispatch(youtubeModal.ChangeVideoIdAction(id));
  }
}
